import { render, staticRenderFns } from "./docViewer.vue?vue&type=template&id=5ba1f838&"
import script from "./docViewer.vue?vue&type=script&lang=js&"
export * from "./docViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports